module.exports = __webpack_public_path__ + "img/vedicpac.45e9cbd1.png";